import i18n from '@/locale/i18n'

import Home from '@/page/demo/demo'
import scroll from '@/page/demo/scrollDemo'
import table from '@/page/demo/tableDemo'
import share from '@/page/demo/shareDemo'
import nav from '@/page/demo/navDemo'
import form from '@/page/demo/form'
import crop from '@/page/demo/cropDemo'

export default [
  {
    path: '/',
    component: Home,
    meta: { title: i18n.t('demo.title') }
  },
  {
    path: '/scroll',
    component: scroll,
    meta: { title: '下拉和上拉加载' }
  },
  {
    path: '/tableDemo',
    component: table,
    meta: { title: '表格' }
  },
  {
    path: '/shareDemo',
    component: share,
    meta: { title: '分享' }
  },
  {
    path: '/navDemo',
    component: nav,
    meta: { title: '导航栏控制' }
  },
  {
    path: '/form',
    component: form,
    meta: { title: '表单校验' }
  },
  {
    path: '/crop',
    component: crop,
    meta: { title: '图片裁剪' }
  }
]



// WEBPACK FOOTER //
// ./src/router/demo/index.js